import { Box, Button, Image, Text } from "@chakra-ui/react";
import { FC } from "react";
import { useSelector } from "react-redux";
import useSession from "../../hooks/useSession";
import { State } from "../../interfaces/State";
import { Channel } from "../../interfaces/tracking";
import { Analytics, EventNames } from "../../utils/tracking";

interface ConfirmUsePhotoProps {
  onClickUsePhoto: () => void;
  onClickRetakePhoto: () => void;
  isMobile: boolean;
  redirectTo: string;
}

export const ConfirmUsePhoto: FC<ConfirmUsePhotoProps> = (props) => {
  const { onClickUsePhoto, onClickRetakePhoto, isMobile } = props;
  const { isLoggedIn } = useSession();
  const { allSelfies } = useSelector((state: State) => state.selfie);
  const platform: string =
    new URLSearchParams(location.search).get("platform") ?? "";

  const onConfirm = () => {
    Analytics.event(Channel.GA, EventNames.PHOTO_APPROVED, {
      login: isLoggedIn(),
      device: isMobile ? "mobile" : "desktop",
      option: props.redirectTo,
      photo_saved: allSelfies?.length ? "yes" : "no",
      source: platform.includes("g-mob")
        ? "native"
        : isMobile
        ? "mobile"
        : "desktop",
    });

    Analytics.event(Channel.TEALIUM, EventNames.SELECT_CONTENT, {
      action_type: "button",
      action_label: EventNames.PHOTO_TAKEN,
    });
    onClickUsePhoto();
  };

  const onCancel = () => {
    Analytics.event(Channel.GA, EventNames.RETAKE_SELECTED, {
      login: isLoggedIn(),
      device: isMobile ? "mobile" : "desktop",
      option: props.redirectTo,
      photo_saved: allSelfies?.length ? "yes" : "no",
      source: platform.includes("g-mob")
        ? "native"
        : isMobile
        ? "mobile"
        : "desktop",
    });

    onClickRetakePhoto();
  };

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent={"space-between"}
      h="max-content"
      gap={{ base: "12px", md: "13px" }}
      px={{ base: "20px", md: "56px" }}
      mt={{ base: "0px", md: "20px" }}
      mb={{ base: "36px", md: "34px" }}
      w="100%"
    >
      <Box
        color={{ base: "#FFFFFF", md: "#000000" }}
        textAlign="left"
        display="flex"
        gap={{ base: "12px", md: "15px" }}
        alignItems={"center"}
      >
        <Image
          src={process.env.PUBLIC_URL + "/assets/images/check.svg"}
          w="37px"
        />

        <Box>
          <Text
            fontSize={{ base: "12px", md: "20px" }}
            fontWeight={{ base: "bold", md: 500 }}
          >
            Your photo has been uploaded!
          </Text>

          <Text fontSize={{ base: "9.72px", md: "16px" }}>
            Would you like to use it?
          </Text>
        </Box>
      </Box>

      <Box display="flex" gap="12px">
        <Button
          background={{ base: "#FFFFFF", md: "#000000" }}
          _active={{ background: { base: "#FFFFFF", md: "#000000" } }}
          _hover={{ background: { base: "#FFFFFF", md: "#000000" } }}
          color={{ base: "#000000", md: "#FFFFFF" }}
          fontSize={{ base: "9px !important", md: "12px !important" }}
          py={{ base: "10px", md: "12px" }}
          px={{ base: "25px", md: "30px" }}
          width={isMobile ? "4rem" : "7rem"}
          h="max-content"
          onClick={onConfirm}
        >
          Yes
        </Button>

        <Button
          background={{ base: "#FFFFFF", md: "#000000" }}
          _active={{ background: { base: "#FFFFFF", md: "#000000" } }}
          _hover={{ background: { base: "#FFFFFF", md: "#000000" } }}
          color={{ base: "#000000", md: "#FFFFFF" }}
          fontSize={{ base: "9px !important", md: "12px !important" }}
          py={{ base: "10px", md: "12px" }}
          px={{ base: "25px", md: "30px" }}
          h="max-content"
          width={isMobile ? "4rem" : "7rem"}
          onClick={onCancel}
        >
          Retake
        </Button>
      </Box>
    </Box>
  );
};
